import React from "react";
import { ASSETS } from "../../data/site";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-slate-900 text-white pt-16 pb-10 px-4 sm:px-6 lg:px-10 border-t-4 border-brand-yellow">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        <div>
          <img src={ASSETS.logo} alt="UniversalHouse TX" className="h-16 w-auto bg-white rounded-2xl p-2 border-4 border-slate-900" />
          <p className="mt-4 text-slate-300 font-quicksand max-w-sm">
            A Universal Studios themed family rental in Frisco, Texas. Sleeps 12. 4 magical themed bedrooms.
          </p>
        </div>
        <div>
          <h4 className="font-fredoka font-bold text-2xl mb-4">Contact</h4>
          <a
            href="mailto:help@universalhousetx.com"
            data-testid="footer-email"
            className="flex items-center gap-3 text-slate-200 hover:text-brand-yellow transition-colors font-quicksand"
          >
            <Mail size={18} /> help@universalhousetx.com
          </a>
          <p className="flex items-center gap-3 text-slate-200 mt-3 font-quicksand">
            <MapPin size={18} /> Frisco, Texas
          </p>
        </div>
        <div>
          <h4 className="font-fredoka font-bold text-2xl mb-4">Explore</h4>
          <ul className="space-y-2 font-quicksand">
            <li><a href="#rooms" className="text-slate-200 hover:text-brand-yellow">Rooms</a></li>
            <li><a href="#amenities" className="text-slate-200 hover:text-brand-yellow">Amenities</a></li>
            <li><a href="#location" className="text-slate-200 hover:text-brand-yellow">Location</a></li>
            <li><a href="#inquiry" className="text-slate-200 hover:text-brand-yellow">Inquiry</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-slate-700 flex flex-col sm:flex-row gap-3 items-center justify-between">
        <p className="text-slate-400 font-quicksand text-sm">© {new Date().getFullYear()} UniversalHouse TX. All rights reserved.</p>
        <p className="text-slate-400 font-quicksand text-sm">Not affiliated with Universal Studios or NBCUniversal.</p>
      </div>
    </footer>
  );
}
